<template>
    <v-container>
        <v-row>
            <v-autocomplete
                :disabled='!disabled'
                :items='items'
                :loading='isLoading'
                :search-input.sync='search'
                dense
                filled
                :rules='rules.contact'
                hide-selected
                item-text='phone'
                label='طرف'
                placeholder='در مخاطبین جستجو کنید'
                return-object
                :error-messages='!disabled ? "ابتدا باید لیست مخاطبان خود را انتخاب کنید":""'
                @change='handleChange'
            >
                <template v-slot:item='data'>
                    <template>
                        <User :user="data.item" :no-status="true" :show-phone="true" small :no-menu="true" class="my-2"></User>
                    </template>
                </template>
                <template slot='no-data'>
                    <v-col>
                        <div class='grey--text text-center mb-3'>موردی یافت نشد</div>
                        <v-btn
                            block
                            color='primary'
                            @click='addContactDialog = true'
                        >
                            ایجاد مخاطب جدید
                        </v-btn>
                    </v-col>
                </template>
            </v-autocomplete>
        </v-row>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';
    import axios from 'axios';
    import User from '@/components/User';

    export default {
        name: 'SearchContact',
        components: {
            User
        },
        props: {
            contact: Object,
            disabled: Boolean,

            type: String,
            query: Object,

            small: Boolean,

            status: String,
            size: {
                type: Number,
                default: 48
            }
        },
        model: {
            props: 'contact',
            event: 'change'
        },
        data: () => ({
            selectedUsers: [],
            onModel: null,
            user: null,
            userImageLoadError: false,
            showAddContact: false,
            userStatus: {
                REGISTERED: { value: 'REGISTERED', label: 'تکمیل اطلاعات نشده', bgColor: 'yellow', color: 'black' },
                COMPLETED: { value: 'COMPLETED', label: 'در انتظار تایید', bgColor: 'grey', color: '#FFFFFF' },
                APPROVED: { value: 'APPROVED', label: 'تایید شده', bgColor: 'blue', color: '#FFFFFF' }
            },
            descriptionLimit: 60,
            contacts: [],
            isLoading: false,
            search: null,

            items: [],
            userItems: [],
            legalUserItem: [],
            owner_residentItem: [],
            personnelItems: [],

            rules:{
                contact: [
                    v => !!v || 'انتخاب طرف اجباری میباشد'
                ],
            }
        }),
        methods: {
            handleChange(item) {
                if (item) {
                    this.$emit('change', ({ onModel: this.onModel, ...item }));
                }
            },
            imageLoadError() {
                this.userImageLoadError = true;
            },
            async fetchData(query) {

                this.isLoading = true;
                await axios
                    .get(`/api/users/me/contacts`,
                        { params:query })
                    .then(res => {
                        this.contacts = res.data.contacts;
                        this.contacts.forEach(item => {
                            this.userItems.push(item.user);
                            this.legalUserItem.push(item.legalUserItem);
                        });
                        this.owner_residentItem = res.data.owner_residentItem;
                    })
                    .catch(error => {
                        console.error(error);
                        this.contacts = [];
                        this.showAddContact = true;
                    });
                this.isLoading = false;
            }
        },
        watch: {
            type(val, newVal) {
                if (val !== newVal) {
                    if (val === 'user') {
                        this.items = this.userItems;
                        this.onModel = 'User';
                    }
                    if (val === 'legalUser') {
                        this.items = this.legalUserItem;
                        this.onModel = 'legalUser';
                    }
                    if (val === 'unit') {
                        this.items = this.owner_residentItem;
                        this.onModel = 'User';
                    }
                    if (val === 'personnel') {
                        this.items = this.personnelItems;
                        this.onModel = 'User';
                    }
                    this.fetchData(this.query);
                }
            }
        },
        computed: {
            ...mapState({ public_url: state => state.public_url })
        },
        async mounted() {
            await this.fetchData(this.query);
            if (this.type) {
                if (this.type === 'user') {
                    this.items = this.userItems;
                    this.onModel = 'User';
                }
                if (this.type === 'legalUser') {
                    this.items = this.legalUserItem;
                    this.onModel = 'legalUser';
                }
                if (this.type === 'unit') {
                    this.items = this.owner_residentItem;
                    this.onModel = 'User';
                }
                if (this.type === 'personnel') {
                    this.items = this.personnelItems;
                    this.onModel = 'User';
                }
            }
        }
    };
</script>

<style scoped lang='scss'>
    .v-card {
        box-shadow: none !important;
        padding: 4px;
    }
</style>
